/**
 * helpCategories — mapping catégorie → icône monochrome (HELP-DRAWER lot §1.2).
 *
 * Utilisé sur les en-têtes de groupe du drawer pour faciliter le balayage visuel.
 * Pensé « dans l'esprit de la future palette globale » → réutilisable par SEARCH.
 */

import {
    BookOpen,
    Building2,
    CalendarDays,
    ClipboardCheck,
    Euro,
    FolderArchive,
    GraduationCap,
    MapPin,
    PenLine,
    Presentation,
    Rocket,
    Settings,
    ShieldCheck,
    Tag,
    type LucideIcon,
} from 'lucide-react'

export const HELP_CATEGORY_ICONS: Record<string, LucideIcon> = {
    demarrage: Rocket,
    'clients-crm': Building2,
    apprenants: GraduationCap,
    'catalogue-formations': BookOpen,
    sessions: CalendarDays,
    intervenants: Presentation,
    'finance-facturation': Euro,
    logistique: MapPin,
    'qualite-reglementaire': ShieldCheck,
    'evaluations-pedagogie': ClipboardCheck,
    'documents-ged': FolderArchive,
    'parametres-administration': Settings,
    'signature-electronique': PenLine,
    autres: Tag,
}

/** Icône d'une catégorie (repli `Tag` si inconnue / nulle). */
export function helpCategoryIcon(category: string | null | undefined): LucideIcon {
    return HELP_CATEGORY_ICONS[category ?? 'autres'] ?? Tag
}
